/**
 * 贈品列(輸入指定折扣碼後,後端自動加進購物車的那一列)。
 *
 * 後端 `backend/src/lib/cart-gifts.ts` 用 line item metadata `gift_promo` 標記;
 * 前台靠它決定:不給刪、數量固定、顯示「贈品」。不是 server action,
 * client component 也能 import。
 */

export const GIFT_METADATA_KEY = "gift_promo"

export type GiftSyncResult = {
  added: { gift_code: string; variant_id: string }[]
  removed: string[]
  skipped: {
    gift_code: string
    variant_id: string
    reason: "out_of_stock" | "unavailable" | "not_free" | string
  }[]
}

export const isGiftLine = (item: {
  metadata?: Record<string, unknown> | null
}): boolean => typeof item.metadata?.[GIFT_METADATA_KEY] === "string"

/** 贈品加不進來(沒庫存 / 下架)時的提示 —— 碼本身有套上,所以不是錯誤 */
export const GIFT_SOLD_OUT_NOTICE = "折扣碼已套用,但贈品已送完"

export const giftWasSkipped = (gifts: GiftSyncResult | null | undefined): boolean =>
  !!gifts?.skipped.some((s) => s.reason === "out_of_stock" || s.reason === "unavailable")
